export default "__VITE_ASSET__CmI2xoEn__"